export const INVOICE_STATUS = {
  DRAFT: "Draft",
  FINALIZED: "Finalized",
  PAID: "Paid",
  VOIDED: "Voided",
} as const;

// Note: "Paid" is intentionally omitted. No production code path writes
// status="Paid" to QuickbooksInvoice — invoices stay Finalized even after
// being fully paid. The "Paid" concept is surfaced via the Payment Status
// filter, which computes payment state from QuickbooksInvoicePayment rows.
export const INVOICE_STATUS_OPTIONS = [
  { label: "Draft", value: INVOICE_STATUS.DRAFT },
  { label: "Finalized", value: INVOICE_STATUS.FINALIZED },
  { label: "Voided", value: INVOICE_STATUS.VOIDED },
];

export type InvoiceStatusType =
  (typeof INVOICE_STATUS)[keyof typeof INVOICE_STATUS];
